import React, { useState, useEffect, Fragment } from "react";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import CardContent from "@mui/material/CardContent";
import { useTranslation } from "react-i18next";
import { Box, Typography, IconButton, FormControl, Select, MenuItem } from "@mui/material";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";

import DataGrid, {
  Column,
  Paging,
  FilterRow,
  HeaderFilter,
  SearchPanel,
  Scrolling,
  Sorting,
  Selection,
  Export,
  Summary,
  TotalItem,
} from "devextreme-react/data-grid";

import StyledCard from "../../shared/general/Card";
import utils from "../../../../utils";
import loading from "../../assets/social-media.gif";

const StyledCardContent = styled(CardContent)({
  height: "100%",
  padding: 24,
});

const StyledWrapDataGrid = styled("div")({
  '& .column-info[role="columnheader"]': { backgroundColor: "#283593", color: "#FFFFFF", fontWeight: "500" },
  '& .column-ot[role="columnheader"]': { backgroundColor: "#7c4dff", color: "#FFFFFF", fontWeight: "500" },
  '& .column-shift[role="columnheader"]': { backgroundColor: "#2196f3", color: "#FFFFFF", fontWeight: "500" },
  "& .dx-datagrid-total-footer": { background: "#fff36b33" },
});

const StyledLoading = styled("div")({
  display: "flex", justifyContent: "center", alignItems: "center", height: "inherit",
});

function nz(v) { return (v !== undefined && v !== null) ? v : null; }
function fmtFixed2(v) { return (v !== undefined && v !== null && !Number.isNaN(v)) ? Number(v).toFixed(2) : ""; }
function sumTextHour(e, t) { return (e && e.value !== undefined && e.value !== null) ? (fmtFixed2(e.value) + " " + t("Hours")) : ""; }
function sumTextBaht(e, t) { return (e && e.value !== undefined && e.value !== null) ? (fmtFixed2(e.value) + " " + t("Baht")) : ""; }
function monthKeyFromDate(dt) { var d = dayjs(dt); return d.isValid() ? d.format("YYYY-MM") : null; }
function monthLabel(key, i18n) { var d = dayjs(key + "-01"); if (!d.isValid()) return key; var isTH = i18n && i18n.resolvedLanguage === "th"; return d.format(isTH ? "MMMM BBBB" : "MMMM YYYY"); }

const TableEmployee = () => {
  const { t, i18n } = useTranslation();

  const summaryTimeCompanyState = useSelector(function (state) { return state.summaryTimeCompany; });
  const summaryTimeList = (summaryTimeCompanyState && summaryTimeCompanyState.result) ? summaryTimeCompanyState.result : null;
  const summaryTimeListFetching = (summaryTimeCompanyState && summaryTimeCompanyState.isFetching) ? summaryTimeCompanyState.isFetching : false;

  const [rows, setRows] = useState([]);
  const [months, setMonths] = useState([]);
  const [currentMonthIndex, setCurrentMonthIndex] = useState(0);

  var gridColumnsOT = [
    { dataField: "otOneHours", caption: "OT 1 (" + t("Hours") + ")", format: "###,###,##0.00", cssClass: "column-ot", width: 150, isShow: 1 },
    { dataField: "otOneAmount", caption: "OT 1 (" + t("Baht") + ")", format: "###,###,##0.00", cssClass: "column-ot", width: 140, isShow: 1 },
    { dataField: "otOneFiveHours", caption: "OT 1.5 (" + t("Hours") + ")", format: "###,###,##0.00", cssClass: "column-ot", width: 150, isShow: 1 },
    { dataField: "otOneFiveAmount", caption: "OT 1.5 (" + t("Baht") + ")", format: "###,###,##0.00", cssClass: "column-ot", width: 140, isShow: 1 },
    { dataField: "otTwoHours", caption: "OT 2 (" + t("Hours") + ")", format: "###,###,##0.00", cssClass: "column-ot", width: 150, isShow: 1 },
    { dataField: "otTwoAmount", caption: "OT 2 (" + t("Baht") + ")", format: "###,###,##0.00", cssClass: "column-ot", width: 140, isShow: 1 },
    { dataField: "otThreeHours", caption: "OT 3 (" + t("Hours") + ")", format: "###,###,##0.00", cssClass: "column-ot", width: 150, isShow: 1 },
    { dataField: "otThreeAmount", caption: "OT 3 (" + t("Baht") + ")", format: "###,###,##0.00", cssClass: "column-ot", width: 140, isShow: 1 },
  ];
  var gridColumnsShift = [
    { dataField: "shiftPayMorning", caption: t("ShiftPayMorning"), format: "###,###,##0.00", cssClass: "column-shift", width: 110, isShow: 1 },
    { dataField: "shiftPayAfternoon", caption: t("ShiftPayAfternoon"), format: "###,###,##0.00", cssClass: "column-shift", width: 110, isShow: 1 },
    { dataField: "shiftPayNight", caption: t("ShiftPayNight"), format: "###,###,##0.00", cssClass: "column-shift", width: 110, isShow: 1 },
    { dataField: "shiftPayTotal", caption: t("ShiftPayTotal"), format: "###,###,##0.00", cssClass: "column-shift", width: 110, isShow: 1 },
  ];

  useEffect(function () {
    var table = (summaryTimeList && Array.isArray(summaryTimeList.dataTable)) ? summaryTimeList.dataTable : [];

    var mapped = table.map(function (el) {
      var dr = (el && el.dataRender) ? el.dataRender : null;
      var dt = (el && el.date) ? el.date : null;
      var dateText = dt
        ? dayjs(dt).format((i18n && i18n.resolvedLanguage === "th") ? "DD MMM BBBB (ddd)" : "DD MMM YYYY (ddd)")
        : "";

      var isWorkingDay = (dr && typeof dr.isWorkingDay === "number") ? dr.isWorkingDay : null;
      var timeIn = (dr && dr.timeIn) ? dr.timeIn : "";
      var timeOut = (dr && dr.timeOut) ? dr.timeOut : "";
      var nameShiftType = (dr && dr.nameShiftType) ? dr.nameShiftType : "";

      var workingTime = "";
      if (isWorkingDay === 1) {
        workingTime = (timeIn ? timeIn.slice(0, -3) : "") + " - " + (timeOut ? timeOut.slice(0, -3) : "");
      } else {
        workingTime = nameShiftType;
      }

      return {
        dateRaw: dt,
        monthKey: dt ? monthKeyFromDate(dt) : null,
        date: dateText,
        workingTime: workingTime,

        otOneHours: nz(el && el.otOneHours),
        otOneAmount: nz(el && el.otOneAmount),
        otOneFiveHours: nz(el && el.otOneFiveHours),
        otOneFiveAmount: nz(el && el.otOneFiveAmount),
        otTwoHours: nz(el && el.otTwoHours),
        otTwoAmount: nz(el && el.otTwoAmount),
        otThreeHours: nz(el && el.otThreeHours),
        otThreeAmount: nz(el && el.otThreeAmount),

        shiftPayMorning: nz(el && el.shiftPayMorning),
        shiftPayAfternoon: nz(el && el.shiftPayAfternoon),
        shiftPayNight: nz(el && el.shiftPayNight),
        shiftPayTotal: nz(el && el.shiftPayTotal),
      };
    });

    var monthSet = {}; var monthArr = [];
    for (var i = 0; i < mapped.length; i++) {
      var mk = mapped[i].monthKey;
      if (mk && !monthSet[mk]) { monthSet[mk] = true; monthArr.push(mk); }
    }
    monthArr.sort(function (a, b) {
      var da = dayjs(a + "-01").valueOf();
      var db = dayjs(b + "-01").valueOf();
      return da - db;
    });

    setRows(mapped);
    setMonths(monthArr);

    var startKey = null;
    if (summaryTimeList && summaryTimeList.start) {
      var d = dayjs(summaryTimeList.start);
      if (d.isValid()) { startKey = d.format("YYYY-MM"); }
    }
    var targetIndex = 0;
    if (startKey) {
      for (var j = 0; j < monthArr.length; j++) {
        if (monthArr[j] === startKey) { targetIndex = j; break; }
      }
    }
    setCurrentMonthIndex(targetIndex);

  }, [summaryTimeList, i18n && i18n.resolvedLanguage]);

  var currentMonthKey = (months && months.length > 0 && currentMonthIndex >= 0 && currentMonthIndex < months.length)
    ? months[currentMonthIndex]
    : null;

  var filteredRows = rows.filter(function (r) { return r && r.monthKey && currentMonthKey && r.monthKey === currentMonthKey; });

  var grand = {
    otOneHours: 0, otOneAmount: 0,
    otOneFiveHours: 0, otOneFiveAmount: 0,
    otTwoHours: 0, otTwoAmount: 0,
    otThreeHours: 0, otThreeAmount: 0,
    shiftPayMorning: 0, shiftPayAfternoon: 0, shiftPayNight: 0, shiftPayTotal: 0,
  };
  for (var gi = 0; gi < rows.length; gi++) {
    var r = rows[gi];
    if (!r) continue;
    grand.otOneHours += (r.otOneHours || 0);
    grand.otOneAmount += (r.otOneAmount || 0);
    grand.otOneFiveHours += (r.otOneFiveHours || 0);
    grand.otOneFiveAmount += (r.otOneFiveAmount || 0);
    grand.otTwoHours += (r.otTwoHours || 0);
    grand.otTwoAmount += (r.otTwoAmount || 0);
    grand.otThreeHours += (r.otThreeHours || 0);
    grand.otThreeAmount += (r.otThreeAmount || 0);

    grand.shiftPayMorning += (r.shiftPayMorning || 0);
    grand.shiftPayAfternoon += (r.shiftPayAfternoon || 0);
    grand.shiftPayNight += (r.shiftPayNight || 0);
    grand.shiftPayTotal += (r.shiftPayTotal || 0);
  }

  function calculateCustomSummary(options) {
    if (!options || !options.name) return;

    if (options.summaryProcess === "start") {
      options.totalValue = 0;
    }
    if (options.summaryProcess === "finalize") {
      if (options.name === "gt_ot1_h") options.totalValue = grand.otOneHours;
      if (options.name === "gt_ot1_a") options.totalValue = grand.otOneAmount;
      if (options.name === "gt_ot15_h") options.totalValue = grand.otOneFiveHours;
      if (options.name === "gt_ot15_a") options.totalValue = grand.otOneFiveAmount;
      if (options.name === "gt_ot2_h") options.totalValue = grand.otTwoHours;
      if (options.name === "gt_ot2_a") options.totalValue = grand.otTwoAmount;
      if (options.name === "gt_ot3_h") options.totalValue = grand.otThreeHours;
      if (options.name === "gt_ot3_a") options.totalValue = grand.otThreeAmount;
      if (options.name === "gt_shift_morning") options.totalValue = grand.shiftPayMorning;
      if (options.name === "gt_shift_afternoon") options.totalValue = grand.shiftPayAfternoon;
      if (options.name === "gt_shift_night") options.totalValue = grand.shiftPayNight;
      if (options.name === "gt_shift_total") options.totalValue = grand.shiftPayTotal;
    }
  }

  function customizeSumHour(e) { return sumTextHour(e, t); }
  function customizeSumBaht(e) { return sumTextBaht(e, t); }

  function handlePrevMonth() { if (currentMonthIndex > 0) setCurrentMonthIndex(currentMonthIndex - 1); }
  function handleNextMonth() { if (months && currentMonthIndex < months.length - 1) setCurrentMonthIndex(currentMonthIndex + 1); }
  function handleSelectMonth(e) {
    var val = (e && e.target) ? e.target.value : null; if (!val) return;
    var idx = 0; for (var i = 0; i < months.length; i++) { if (months[i] === val) { idx = i; break; } }
    setCurrentMonthIndex(idx);
  }

  return (
    <Fragment>
      <StyledCard>
        <StyledCardContent>
          {summaryTimeListFetching ? (
            <StyledLoading><img width="80" alt="loading" src={loading} /></StyledLoading>
          ) : (
            <Fragment>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2, gap: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <IconButton onClick={handlePrevMonth} disabled={!(currentMonthIndex > 0)} size="small" aria-label="Previous month">
                    <ArrowBackIosNewRoundedIcon fontSize="small" />
                  </IconButton>
                  <Typography variant="h6" sx={{ minWidth: 220 }}>
                    {currentMonthKey ? monthLabel(currentMonthKey, i18n) : "-"}
                  </Typography>
                  <IconButton onClick={handleNextMonth} disabled={!(months && currentMonthIndex < months.length - 1)} size="small" aria-label="Next month">
                    <ArrowForwardIosRoundedIcon fontSize="small" />
                  </IconButton>
                </Box>
              </Box>

              <StyledWrapDataGrid>
                <DataGrid
                  dataSource={Array.isArray(filteredRows) ? filteredRows : []}
                  showBorders
                  showColumnLines
                  rowAlternationEnabled
                  columnAutoWidth
                >
                  <Column caption={t("Date")} dataField="date" dataType="string" cssClass="column-info" />
                  <Column caption={t("TimeAttendance")} dataField="workingTime" dataType="string" cssClass="column-info" />

                  {gridColumnsOT.map(function (item, idx) {
                    return item.isShow ? (
                      <Column key={"ot-col-" + idx} dataField={item.dataField} caption={item.caption}
                        format={item.format} cssClass={item.cssClass} width={item.width} alignment="center" />
                    ) : null;
                  })}

                  {gridColumnsShift.map(function (item, idx) {
                    return item.isShow ? (
                      <Column key={"shift-col-" + idx} dataField={item.dataField} caption={item.caption}
                        format={item.format} cssClass={item.cssClass} width={item.width} alignment="center" />
                    ) : null;
                  })}

                  <Summary calculateCustomSummary={calculateCustomSummary}>
                    <TotalItem
                      name="gt_label"
                      showInColumn="date"
                      summaryType="custom"
                      customizeText={() => t("TotalValue")}
                    />

                    <TotalItem name="gt_ot1_h" showInColumn="otOneHours" summaryType="custom" customizeText={customizeSumHour} valueFormat={{ type: "fixedPoint", precision: 2 }} />
                    <TotalItem name="gt_ot1_a" showInColumn="otOneAmount" summaryType="custom" customizeText={customizeSumBaht} valueFormat={{ type: "fixedPoint", precision: 2 }} />
                    <TotalItem name="gt_ot15_h" showInColumn="otOneFiveHours" summaryType="custom" customizeText={customizeSumHour} valueFormat={{ type: "fixedPoint", precision: 2 }} />
                    <TotalItem name="gt_ot15_a" showInColumn="otOneFiveAmount" summaryType="custom" customizeText={customizeSumBaht} valueFormat={{ type: "fixedPoint", precision: 2 }} />
                    <TotalItem name="gt_ot2_h" showInColumn="otTwoHours" summaryType="custom" customizeText={customizeSumHour} valueFormat={{ type: "fixedPoint", precision: 2 }} />
                    <TotalItem name="gt_ot2_a" showInColumn="otTwoAmount" summaryType="custom" customizeText={customizeSumBaht} valueFormat={{ type: "fixedPoint", precision: 2 }} />
                    <TotalItem name="gt_ot3_h" showInColumn="otThreeHours" summaryType="custom" customizeText={customizeSumHour} valueFormat={{ type: "fixedPoint", precision: 2 }} />
                    <TotalItem name="gt_ot3_a" showInColumn="otThreeAmount" summaryType="custom" customizeText={customizeSumBaht} valueFormat={{ type: "fixedPoint", precision: 2 }} />

                    <TotalItem name="gt_shift_morning" showInColumn="shiftPayMorning" summaryType="custom" customizeText={customizeSumBaht} valueFormat={{ type: "fixedPoint", precision: 2 }} />
                    <TotalItem name="gt_shift_afternoon" showInColumn="shiftPayAfternoon" summaryType="custom" customizeText={customizeSumBaht} valueFormat={{ type: "fixedPoint", precision: 2 }} />
                    <TotalItem name="gt_shift_night" showInColumn="shiftPayNight" summaryType="custom" customizeText={customizeSumBaht} valueFormat={{ type: "fixedPoint", precision: 2 }} />
                    <TotalItem name="gt_shift_total" showInColumn="shiftPayTotal" summaryType="custom" customizeText={customizeSumBaht} valueFormat={{ type: "fixedPoint", precision: 2 }} />
                  </Summary>


                  {/* แสดงเฉพาะเดือนปัจจุบันที่เลือก */}
                  <Paging enabled={false} />
                  <Scrolling columnRenderingMode="virtual" />
                  <Selection mode="single" />
                  <Sorting mode="multiple" />
                  <FilterRow visible={false} />
                  <HeaderFilter visible />
                  <SearchPanel visible width={240} placeholder={t("Search")} />
                  <Export enabled allowExportSelectedData />
                </DataGrid>
              </StyledWrapDataGrid>
            </Fragment>
          )}
        </StyledCardContent>
      </StyledCard>
    </Fragment>
  );
};

export default TableEmployee;
